import React from 'react';
import styles from './Logo.module.css';
import logoImage from '../../assets/images/FidocoLogoV2Black.png';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'light' | 'dark';
  className?: string;
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  variant = 'dark',
  className = '',
  showText = false
}) => {
  return (
    <div className={`${styles.logo} ${styles[size]} ${styles[variant]} ${className}`}>
      {/* The header logo is above the fold, so it loads eagerly — lazy-loading
          it only delayed the first paint. The intrinsic dimensions let the
          browser reserve space and avoid layout shift; CSS sets the real size. */}
      <img
        src={logoImage}
        alt="Fidoco"
        className={styles.logoImage}
        loading="eager"
        decoding="async"
        width={380}
        height={144}
      />
      {showText && <span className={styles.logoText}>Fidoco</span>}
    </div>
  );
};

export default Logo;
